import { Component, OnDestroy, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AuthenticationService } from '../../shared/authentication.service';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { ApiService } from '../../shared/api.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.css']
})
export class UserManagementComponent implements OnInit, OnDestroy {

  isAdmin = false;
  isOrgAdmin = false;
  userData: any;
  idToken: string;
  displayedColumns: string[] = ['uid', 'displayName', 'email', 'role', 'orgId'];
  userList: any[];
  userListFiltered: any[];
  dataSource: MatTableDataSource<any>;
  userRole: string;
  userOrgId: string;
  authRoles: Array<string> = ['admin', 'superuser'];
  loading = true;
  userSubscription: Subscription;
  roles: string[] = ['user', 'labuser', 'admin'];
  isSortedUID = false;
  isSortedDisplayName = false;
  isSortedEmail = false;
  isSortedRole = false;
  isSortedOrg = false;
  orgsDataArray = [];
  preparedOrgUpdateData: [string, string, string];
  isEditing = false;

  constructor(
    private angularFireAuth: AngularFireAuth,
    private authenticationService: AuthenticationService,
    private router: Router,
    private apiService: ApiService
  ) {
  }

  ngOnInit(): void {
    this.userSubscription = this.angularFireAuth.authState.subscribe(async user => {
      if (user && user.uid) {
        this.isAdmin = this.authenticationService.isAdmin;
        this.isOrgAdmin = this.authenticationService.isOrgAdmin;
        this.userData = this.authenticationService.userData;
        this.userRole = this.authenticationService.userRole;
        const token = await user.getIdTokenResult();
        this.idToken = token.token;
        this.userOrgId = await this.authenticationService.getUserOrgId();
        console.log(this.userOrgId);

        if (this.authRoles.indexOf(this.userRole) === -1 || !this.userData || !this.idToken) {
          await this.router.navigate(['/']);
        }
        if (this.userRole === 'superuser') {
          this.roles.push('superuser');
        }
        await this.getUsers();
      } else {
        await this.router.navigate(['/']);
      }
    });
  }

  async getUsers() {
    this.loading = true;
    if (this.userRole === 'superuser') {
      this.userList = await this.apiService.getAllUsers(this.idToken);
      // await this.apiService.cleanUsers(this.idToken, this.userList);
      await this.getUserOrgData();
    } else {
      this.userList = await this.apiService.getOrgUsers(this.idToken, this.userOrgId);
      this.userList = this.userList.map(user => user.userRecord);
      this.userList = this.userList.filter(userData => userData.customClaims?.role !== 'superuser');
      await this.getUserOrgData();
    }

    this.loading = false;

  }

  async getUserOrgData() {
    this.orgsDataArray = [];

    this.userListFiltered = this.userList;
    console.log(this.userList);
    if (this.userRole === 'superuser') {
      this.orgsDataArray = await this.apiService.getAllOrgs(this.idToken);
    } else {
      const orgsArray = [...new Set(this.userList.map(
        userData => userData.customClaims?.orgData?.orgId?.toString()))].filter(org => org !== undefined);
      console.log(orgsArray);
      // get array of all orgs of users ot minimize API calls
      for (const org of orgsArray) {
        try {
          if (org) {
            const data = await this.apiService.getOrgData(this.idToken, org);
            this.orgsDataArray.push(data);

          } else {
            const data = {name: 'No Organization', id: '', active: true};
            this.orgsDataArray.push(data);
          }
        } catch (e) {
          const data = {name: 'No Organization', id: '', active: true};
          this.orgsDataArray.push(data);
        }
      }
    }
    console.log(this.orgsDataArray);
    for (const userData of this.userList) {
      if (userData.customClaims) {
        userData.customClaims.orgData = this.orgsDataArray.find(orgData => {
          // console.log(orgData.id, userData.customClaims?.orgId ? userData.customClaims?.orgId : userData.customClaims?.orgData?.orgId ? userData.customClaims?.orgData?.orgId : '');
          return orgData.id === userData.customClaims?.orgData?.orgId;
        });
      }
    }
    // get data for each org
    // console.log(orgsDataArray);
    this.dataSource = new MatTableDataSource(this.userList);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.userListFiltered = this.userList.filter(user => {
      return user.uid.toLowerCase().includes(filterValue.trim().toLowerCase()) ||
        user.displayName?.toLowerCase().includes(filterValue.trim().toLowerCase()) ||
        user.email?.toLowerCase().includes(filterValue.trim().toLowerCase()) ||
        user.customClaims?.orgData?.name.toLowerCase().includes(filterValue.trim().toLowerCase());
    });
  }

  ngOnDestroy() {
    this.userSubscription.unsubscribe();
  }

  handleOrgDataChange(dataArray: [string, string, string]) {
    console.log(dataArray);
    this.preparedOrgUpdateData = dataArray;
    console.log(this.preparedOrgUpdateData);
  }

  async updateUserOrgData(user) {
    const input = document.getElementById('displayInput' + user.uid) as HTMLInputElement;
    if (input.value !== user.displayName) {
      await this.apiService.updateUserDetails({displayName: input.value}, user.uid, this.idToken);
    }
    if (this.preparedOrgUpdateData) {
      const [uid, userRole, orgId] = this.preparedOrgUpdateData;
      await this.apiService.updateUserOrgData(this.idToken, orgId, uid, userRole);
    }

    await this.getUsers();

    this.isEditing = false;

  }

  editUsers($event, user) {
    this.isEditing = true;
    user.isEditing = true;

    $event = $event as HTMLElement;
    const target = $event.target.style;
    target.visibility = 'visible';

    const matSelectArray = $event.target.parentElement.parentElement.querySelectorAll('.mat-select-cell');
    for (const matSelectCell of matSelectArray) {
      matSelectCell.style.visibility = 'visible';
    }
    const nameCellArray = $event.target.parentElement.parentElement.querySelectorAll('.name-cell');
    for (const nameCell of nameCellArray) {
      nameCell.style.display = 'none';
    }
  }

  onSort($event: MouseEvent) {
    const target = $event.target as HTMLElement;
    switch (target.id) {

      case 'uidHead':
        console.log('Sorting by UID');
        if (this.isSortedUID) {
          this.userListFiltered.sort((a, b) =>
            (a.uid.toLowerCase() > b.uid.toLowerCase()) ? -1 : ((b.uid.toLowerCase() > a.uid.toLowerCase()) ? 1 : 0));
          this.isSortedUID = !this.isSortedUID;
        } else {
          this.userListFiltered.sort((a, b) =>
            (a.uid.toLowerCase() > b.uid.toLowerCase()) ? 1 : ((b.uid.toLowerCase() > a.uid.toLowerCase()) ? -1 : 0));
          this.isSortedUID = !this.isSortedUID;
        }
        break;

      case 'displayNameHead':
        console.log('Sorting by display name');
        if (this.isSortedDisplayName) {
          this.userListFiltered.sort((a, b) =>
            (a.displayName?.toLowerCase() > b.displayName?.toLowerCase()) ? -1 :
              ((b.displayName?.toLowerCase() > a.displayName?.toLowerCase()) ? 1 : 0));
          this.isSortedDisplayName = !this.isSortedDisplayName;
        } else {
          this.userListFiltered.sort((a, b) =>
            (a.displayName?.toLowerCase() > b.displayName?.toLowerCase()) ? 1 :
              ((b.displayName?.toLowerCase() > a.displayName?.toLowerCase()) ? -1 : 0));
          this.isSortedDisplayName = !this.isSortedDisplayName;
        }
        break;

      case 'emailHead':
        console.log('Sorting by email');
        if (this.isSortedEmail) {
          this.userListFiltered.sort((a, b) =>
            (a.email.toLowerCase() > b.email.toLowerCase()) ? -1 : ((b.email.toLowerCase() > a.email.toLowerCase()) ? 1 : 0));
          this.isSortedEmail = !this.isSortedEmail;
        } else {
          this.userListFiltered.sort((a, b) =>
            (a.email.toLowerCase() > b.email.toLowerCase()) ? 1 : ((b.email.toLowerCase() > a.email.toLowerCase()) ? -1 : 0));
          this.isSortedEmail = !this.isSortedEmail;
        }
        break;

      case 'orgHead':
        console.log('Sorting by organization');
        if (this.isSortedOrg) {
          this.userListFiltered.sort((a, b) =>
            (a.customClaims?.orgData?.name?.toLowerCase() > b.customClaims?.orgData?.name?.toLowerCase()) ? -1 :
              ((b.customClaims?.orgData?.name?.toLowerCase() > a.customClaims?.orgData?.name?.toLowerCase()) ? 1 : 0));
          this.isSortedOrg = !this.isSortedOrg;
        } else {
          this.userListFiltered.sort((a, b) =>
            (a.customClaims?.orgData?.name?.toLowerCase() > b.customClaims?.orgData?.name?.toLowerCase()) ? 1 :
              ((b.customClaims?.orgData?.name?.toLowerCase() > a.customClaims?.orgData?.name?.toLowerCase()) ? -1 : 0));
          this.isSortedOrg = !this.isSortedOrg;
        }
        break;

      case 'roleHead':
        console.log('Sorting by role');
        if (this.isSortedRole) {
          this.userListFiltered.sort((a, b) =>
            (a.customClaims?.userRole?.toLowerCase() > b.customClaims?.userRole?.toLowerCase()) ? -1 :
              ((b.customClaims?.userRole?.toLowerCase() > a.customClaims?.userRole?.toLowerCase()) ? 1 : 0));
          this.isSortedRole = !this.isSortedRole;
        } else {
          this.userListFiltered.sort((a, b) =>
            (a.customClaims?.userRole?.toLowerCase() > b.customClaims?.userRole?.toLowerCase()) ? 1 :
              ((b.customClaims?.userRole?.toLowerCase() > a.customClaims?.userRole?.toLowerCase()) ? -1 : 0));
          this.isSortedRole = !this.isSortedRole;
        }
        break;

      default:
    }


  }


  async navigateToUser(user) {
    await this.router.navigate(['/user/', user.uid], {state: user});

  }
}
